import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Seo from '../../seo/Seo';
import PublicFooter from './PublicFooter';
import PublicHeader from './PublicHeader';

const HEADER_OFFSET = 96;

/** Shell for every public page: navigation, metadata, footer, hash scrolling. */
export const PublicLayout = ({ children, testId }) => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    // Anchor targets mount with the page, so give React a frame before scrolling.
    const timer = setTimeout(() => {
      const el = document.getElementById(hash.slice(1));
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 80);
    return () => clearTimeout(timer);
  }, [hash, pathname]);

  return (
    <div className="min-h-screen bg-white text-gray-900" data-testid={testId}>
      <Seo />
      <PublicHeader />
      <main className="pt-20">{children}</main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
